<template>
    <div class="row userslistmainpage">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <div class="header-title w-100 d-flex justify-content-between align-items-center mb-3">
                        <h4 class="card-title float-left">User List</h4>
                         <i class="noformobile">Hi {{ $store.state.user.userInfo.name }}!</i>
                    </div>
                </div>
                <div class="htheightDash pad15fk">
                    <div class="card-body datasearchpartuser">
                        <div class="row justify-content-between">
                            <div class="col-sm-10">
                                <div id="user_list_datatable_info" class="dataTables_filter">
                                    <input type="hidden" name="teamEditId" id="teamEditId">
                                    <div class="row">
                                        <div class="col-sm-4">    
                                            <div class="form-group mb-0">
                                                <input type="search" class="form-control" id="searchTxtId" placeholder="Search..." aria-controls="user-list-table" v-on:keyup="reloadSearch()">
                                            </div>
                                        </div>
                                        <div class="col-sm-4">                    
                                            <Select2 v-model="myValue" 
                                                v-bind:id="'teamStatusFilterId'"
                                                :select=2 
                                                :options="$store.state.stausOptions" 
                                                :placeholder="'Select Status'"
                                                :settings="{ minimumResultsForSearch: -1 }"
                                                @change="myChangeEvent($event)" 
                                                @select="mySelectEvent($event)"
                                            />
                                        </div>
                                        <div class="col-sm-4">                    
                                            <Select2 v-model="myValueRole" 
                                                v-bind:id="'companyFilterId'"
                                                :select=2 
                                                :options="$store.state.role.RoleList" 
                                                :placeholder="'Select Status'"
                                                :settings="{ minimumResultsForSearch: -1 }"
                                                @change="myChangeEvent($event)" 
                                                @select="mySelectEvent($event)"
                                            />
                                        </div>
                                        <!-- <div class="col-sm-4 col-md-4">                    
                                            <Multiselect 
                                                v-model="myValueRole" 
                                                mode="multiple"
                                                :hide-selected="false"
                                                :caret="true"
                                                class="form-control"
                                                :searchable="true"
                                                :create-option="true"
                                                :options="$store.state.role.RoleFilterList"
                                                @change="myChangeEvent($event)"
                                                placeholder="Select Roles"
                                                v-bind:name="'companyId[]'"
                                                v-bind:id="'companyFilterId'"
                                            />    
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="user-list-files d-flex">
                                    <AddEditUsers @reload-table-data="reloadSearch" ref="childComponentTeamRef"/>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive listingtables">
                            <table id="user-list-table" class="table" role="grid" aria-describedby="user-list-page-info">
                                <thead>
                                    <tr>
                                        <th scope="col">Image</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Role</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody class="tbodyCls shimmer-wrapper"  v-if="$store.state.user.tableLoader === 1">
                                    <tr class="text-center " v-for="index in 15" :key="index">
                                        <td v-for="index1 in 6" :key="index1">
                                            <span class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate"></span>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody class="tbodyCls" v-else-if="$store.state.user.tableLoader === 2">
                                    <tr class="text-center">
                                        <td colspan="6">
                                            <ComponentNoData />
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr v-for="(item) in $store.state.user.teamList" :key="item._id">
                                        <td class="">
                                            <img 
                                                class="rounded img-fluid avatar-40" 
                                                :src="img_url+''+item.user_image" :id="'img-'+item._id" 
                                                :alt="item.name" 
                                                @error="imageLoadError(item._id)" />
                                        </td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.email }}</td>
                                        <td style="text-transform: capitalize;">{{ item.role }}</td>
                                        <td v-if="item.status === true">
                                            <div class="custom-switch-wrapper">
                                                <input 
                                                    class="custom-switch" 
                                                    type="checkbox" 
                                                    role="switch" 
                                                    v-bind:id="buttonId(item._id)" 
                                                    v-bind:dataId="item._id" 
                                                    v-bind:dataVal="item.status" 
                                                    checked="" 
                                                    v-on:click="teamStatusModal(item._id, item.status)">
                                                <label  v-bind:for="buttonId(item._id)" ></label>
                                            </div>
                                        </td>
                                        <td v-else>
                                            <div class="custom-switch-wrapper">
                                                <input 
                                                    class="custom-switch" 
                                                    type="checkbox" 
                                                    role="switch" 
                                                    v-bind:id="buttonId(item._id)" 
                                                    v-bind:dataId="item._id" 
                                                    v-bind:dataVal="item.status" 
                                                    v-on:click="teamStatusModal(item._id, item.status)">
                                                <label  v-bind:for="buttonId(item._id)" ></label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="flex align-items-center list-user-action">
                                                <a class="iq-bg-primary mr-1" href="javascript:;" v-on:click="modalEditOpen(item._id)"><i class="ri-pencil-line" ></i></a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="w-100 d-flex align-items-center justify-content-between mt-3">
                            <div id="user-list-page-info" class="col-md-6">
                                <span v-if="page * pageLength > $store.state.user.totalRecord">Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{
                                formatMoney($store.state.user.totalRecord) }} of {{ formatMoney($store.state.user.totalRecord) }} entries</span>
                                <span v-else>Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{ formatMoney(page * pageLength) }} of {{
                                formatMoney($store.state.user.totalRecord) }} entries</span> 
                            </div>
                            <n-pagination
                                v-model:page="page"
                                :page-count="totalLenght"
                                @update:page="reloadPagination"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <input type="hidden" class="teamValId" id="teamValId"/>
    <input type="hidden" class="teamStatusId" id="teamStatusId"/>
</template>
<script>
import AddEditUsers from './AddEditUsers.vue';
// import Multiselect from '@vueform/multiselect'
import Select2 from 'vue3-select2-component';
import axios from 'axios'
import No_image_available from '../../assets/images/No_image_available.svg.png'
import ComponentNoData from '../Widgets/Icon/ComponentNoData.vue';
import $ from "jquery";
import {
    ref
} from 'vue';
import {
formatMoney,
    startLoader,
    finishLoader
} from '../../utils/helper.js'
import 
    { postCommon } 
from '../../utils/api.js'
import { NPagination } from 'naive-ui'
export default {
    name: 'UsersListingPage',
    components: {
        AddEditUsers,
        Select2,
        ComponentNoData,
        // Multiselect,
        NPagination,
    },
    data() {
        return {
            img_url: process.env.VUE_APP_IMG_URL,
            currentx: 5,
            page: 1,
            pageLength: this.$store.state.showEntries,
            searchKey: '',
            totalLenght: 0,
            teamList: [],
            myValueRole: [],
            myValue: 'true',
            taskListHeight: 0,
            taskMainListHeight: 0,
        }
    },
    async mounted() {
        this.$store.state.pageTitle = 'Team Member'
        if (this.$store.state.isActiveToken != '1') {
            // console.log(this.currentDate);
        } else {
            await this.loadTeamData();
            let temps = this
            $("body").on("click", '#searchTxtId', function () {
                if ($('#searchTxtId').val() != '') {
                    $('#searchTxtId').val('');
                    this.searchKey = '';
                    this.page = 1;
                    temps.reloadSearch()
                }
            });
        }
    },
    computed: {
        iAT() {
            return this.$store.state.user.roleId
        },
    },
    watch: {
        async iAT(newValue) {
            if (this.$store.state.user.roleId != '') {
                await this.loadTeamData();
            }
            return newValue
        },
    },
    methods: {
        formatMoney,
        buttonId(id) {
            return "team" + id;
        },
        startLoader,
        finishLoader,
        myChangeEvent(val) {
            // this.myValueRole = val
            this.myValueRole = val ? (Array.isArray(val) ? val : [val]) : [];

            // this.myValueRole = Array.isArray(val) ? [val] : [val];
            this.loadTeamData();
        },
        mySelectEvent({ id, text }) {
            console.log({ id, text })
            this.page = 1;
            this.loadTeamData();
        },
        imageLoadError(id) {
            $('#img-'+id).attr('src',No_image_available);
        },  
        async reloadSearch() {
            const searchCls = document.getElementById('searchTxtId').value;
            this.searchKey = searchCls.trim();
            this.page = 1;
            this.loadTeamData();
        },
        async reloadPagination(itemObjKey) {
            if (itemObjKey > 0 && itemObjKey !== -1 && itemObjKey <= this.totalLenght) {
                this.page = itemObjKey;
                this.loadTeamData();
            }
        },
        async loadTeamData() {
            this.startLoader();
            var roleIds = [];
            let token = localStorage.getItem('mDrivetoken');
            if (!token) {
                this.$store.state.user.accessToken = ''
            }
            let teamStatusFilterId = document.getElementById('teamStatusFilterId').value
            let status = teamStatusFilterId;
            roleIds = this.myValueRole;

            if (this.$store.state.user.teamList.length == 0) {
                this.$store.state.user.tableLoader = 1
            }
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
            await axios.get(process.env.VUE_APP_API_URL + 'user/list', {
                params: {
                    page: this.page,
                    pageLength: this.pageLength,
                    searchKey: this.searchKey,
                    status: status,
                    'role_id[]': roleIds,
                }
                })
                .then((resp) => {
                    if (resp.status == 200 && resp.data.status == 'success') {
                        this.teamList = []
                        this.teamList = resp.data.data.records
                        this.totalRecord = resp.data.data.totalRecord
                        this.totalLenght = this.totalRecord / this.pageLength
                        this.totalLenght = Math.ceil(this.totalLenght);
                        if (this.teamList.length > 0) {
                            this.$store.state.user.tableLoader = 3
                        } else {
                            this.$store.state.user.tableLoader = 2
                        }
                        this.$store.state.user.teamList = resp.data.data.records
                        this.$store.state.user.totalLenght = this.totalLenght
                        this.$store.state.user.totalRecord = resp.data.data.totalRecord
                        this.finishLoader();
                    }else{
                        this.$store.state.user.accessToken = ''
                        this.$store.state.isActiveToken = ''
                        this.$store.state.user.userInfo = ''
                        localStorage.removeItem("userInfo");
                        localStorage.removeItem("mDrivetoken");
                        this.$router.push({
                            name: 'Login'
                        })
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                    console.log("response", error.response.status);
                    console.log("message", error.response.data.message);
                    // this.errorRes = error.response.data.message;
                })
        },
        async teamStatusModal(_id, status) {
            document.getElementById('teamStatusId').value = status
            document.getElementById('teamValId').value = _id
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure you want to update status?',
                accept: this.teamStatusChange,
                cancel: this.teamStatusCloseChange
            })
        },
        async teamStatusCloseChange() {
            // const teamStatusId = document.getElementById('teamStatusId').value
            let teamValId = document.getElementById('teamValId').value
            let teamValIdsds = true;
            if (teamValId === 'false') {
                teamValIdsds = false;
            }
            document.getElementById("team" + teamValId).checked = teamValIdsds;
            // this.loadTeamData();
        },
        async teamStatusChange() {
            this.formLoader = 2
            const teamStatusId = document.getElementById('teamStatusId').value
            let teamValId = document.getElementById('teamValId').value
            let teamValIdsds = false;
            if (teamStatusId === 'false') {
                teamValIdsds = true;
            }
            this.startLoader();

            let _post = {}
            _post = {
                status: teamValIdsds,
                user_id: teamValId,
            }
            const resp = await postCommon('user/status-update', _post)
            if (resp.status == 200 && resp.data.status == 'success') {
                this.$toast.success(resp.data.message);
                this.loadTeamData();
                this.finishLoader();
            } else if (resp.status == 200 && resp.data.status == 'failure') {
                this.errorMessage = resp.data.data;
                this.errorRes = resp.data.message;
            }
            this.formLoader = 1
        },
        async modalEditOpen(team_id) {
            $('.teamValId').val(team_id);
            this.callChildTeamMethod();
        },
    },
    setup() {
        const childComponentTeamRef = ref(null);
        const callChildTeamMethod = () => {
            if (childComponentTeamRef.value) {
                childComponentTeamRef.value.modalEditOpen();
            }
        };
        return {
            childComponentTeamRef,
            callChildTeamMethod,
        };
    },
}
</script>